export default "__VITE_ASSET__DYIBwK33__"